import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const GastoService = {
    getAll: async () => {
        const response = await getAxios().get('/api/gastos');
        return response.data;
    },
    
    getById: async (id) => {
        const response = await getAxios().get(`/api/gastos/${id}`);
        return response.data;
    },

    create: async (gasto) => {
        const response = await getAxios().post('/api/gastos', gasto);
        return response.data;
    },

    update: async (id, gasto) => {
        const response = await getAxios().put(`/api/gastos/${id}`, gasto);
        return response.data;
    },

    delete: async (id) => {
        const response = await getAxios().delete(`/api/gastos/${id}`);
        return response.data;
    }
};
